import { useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import { Formik } from "formik";
import InputField from "../../components/forms/input-field";
import ToggleSwitch from "../../components/forms/toggle-switch";
import TextAreaField from "../../components/forms/textarea-field";
import TabsComponent from "../../components/helper-components/tabs-component";
import Originator from "./originator";
import * as Yup from "yup";
const ApprovalWorkFlow = () => {
  const onSubmit = (values, actions) => {
    console.log(JSON.stringify(values, null, 2));
  };

  const [initialValues, setInitialValues] = useState({
    flow_name: "",
    is_active: true,
    description:""
  });

  const validationSchema = Yup.object().shape({
    flow_name: Yup.string().required("Name is required"),
  });
  const [currentTab, setCurrentTab] = useState("Originator");
  return (
    <InnerLayout title="Create Approval Work Flow" backBtn={true}>
      <Formik
        enableReinitialize={true}
        onSubmit={onSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({ values, setFieldValue, handleSubmit, errors }) => (
        <form
            onSubmit={handleSubmit}
            className="flex flex-col w-full h-full p-4 overflow-hidden"
            >
            <div className="flex flex-col flex-1 overflow-auto min-w-0 min-h-0">
                <div className="flex-shrink-0 w-full">
                <div className="w-full">
                    <div className="flex items-start gap-4 flex-wrap">
                    <div className="w-full md:w-1/2">
                        <InputField
                        type="text"
                        name="flow_name"
                        placeholder="Enter Flow Name"
                        label="Name"
                        isRequired={true}
                        labelWidth="7rem"
                        />
                    </div>
                    <div className="flex items-center mt-[10px]">
                        <label
                        htmlFor="is_active"
                        className="text-[length:var(--input-label-font-size)] text-[var(--input-label-color)] font-[var(--input-label-font-weight)] flex items-center gap-2"
                        >
                        Active
                        </label>
                        <div className="ml-2 mt-[2px]">
                        <ToggleSwitch
                            checked={values.is_active}
                            onClick={() =>
                            setFieldValue("is_active", !values.is_active)
                            }
                        />
                        </div>
                    </div>
                    </div>
                    <div className="mt-4">
                    <TextAreaField
                        label="Description"
                        placeholder="Enter Description"
                        name="description"
                        id="description"
                        labelWidth="7rem"
                    />
                    </div>
                </div>
                </div>
                <div className="flex-1 flex flex-col min-h-0 mt-4">
                <TabsComponent
                    handleClickfn={(item) => setCurrentTab(item)}
                    itemTabs={itemTabs}
                    setCurrentTab={setCurrentTab}
                    currentTab={currentTab}
                />

                <div className="flex-1 overflow-auto">
                    {currentTab === "Originator" && (
                        <Originator/>
                    )}
                </div>
                </div>
            </div>
            </form>
        )}
      </Formik>
    </InnerLayout>
  );
};

export default ApprovalWorkFlow;

const itemTabs = [
    "Originator",
    "Documents & Terms",
    "Stages",
    "Approval Path"
];
